module.exports = __webpack_public_path__ + "static/media/stat-sample-mobile.7f5f653d.png";